<template>
	<div id="app" class="app">
		<div v-if="device">
			<HelloWorld />
		</div>
		<div v-else >
			<mobile/>
		</div>
	</div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import mobile from './components/mobile.vue'

export default {
	name: 'App',
	components: {
		HelloWorld,
		mobile,
	},
	data() {
		return {
			device:true,
		};
	},
	mounted() {
		if (this.isMobile()) {
			//alert("手机端");
			this.device = false;
		} else {
			//alert("pc端");
			this.device = true;
		}
		
		var JsSrc =(navigator.language || navigator.browserLanguage).toLowerCase();
		//JsSrc = "en";
		if(JsSrc.indexOf('zh')>=0){
			// 假如浏览器语言是中文
	
			var domain = document.domain;
			if(domain.indexOf("ai-aitech.com")>=0){//ai-aitech.com   localhost
				this.$i18n.locale = 'en';
			}
			else{
				this.baidu();
				this.$i18n.locale = 'zh';
			}
			
		}
		else if(JsSrc.indexOf('en')>=0){
			// 假如浏览器语言是英文
			this.$i18n.locale = 'en';
		}
		else{
			// 假如浏览器语言是其它语言
			this.$i18n.locale = 'en';
		}
			
	},
	methods:{
		isMobile() {
			let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
			return flag;
		},
		baidu(){
			var _hmt = _hmt || [];
			(function() {
				
				var hm = document.createElement("script");
				hm.id = "baidu";
				hm.src = "https://hm.baidu.com/hm.js?41feafabb818e61f779e0a9f141175da";
				var s = document.getElementsByTagName("script")[0]; 
				s.parentNode.insertBefore(hm, s);
				
				
			})();
		}
	}
	
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding:0px;
  margin:0px;
  position:absolute;
  top:0px;
  left:0px;
  width:100%;
  height:100%;
  border:hidden;
}
</style>
